import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Input
} from 'reactstrap';

class Mobile extends Component {
  getMobileElements = () => {
    const { meta } = this.props;

    let mobilePaginatorElements = [];
    const totalPage = meta.last_page;
    const currentPage = meta.current_page;
    for( let i=1;i <= totalPage;i++ ) {
      mobilePaginatorElements.push(i);
    }

    return { mobilePaginatorElements, totalPage, currentPage };
  }

  renderMobilePaginationElements = (item, totalPage) => {
    return <option
      key={item}
      value={item}
    >
      {`${item} / ${totalPage}`}
    </option>
  }

  render() {
    const { mobilePaginatorElements, totalPage ,currentPage} = this.getMobileElements();
    return (
      <div className="paginator-footer paginator-footer--mobile d-block d-xl-none mobile-pagination-input">
        <Pagination
          className="pagination justify-content-center"
          listClassName="justify-content-center mb-0 align-items-center"
        >
          <PaginationItem className={(currentPage === 1 ? 'disabled' : 'cursor-pointer')}>
            <PaginationLink
              onClick={
                e => {
                  e.preventDefault();
                  this.props.changePage(currentPage - 1);
                }
              }
              tabIndex="-1"
            >
              <i className="fas fa-angle-left" />
              <span className="sr-only">
                        <FormattedMessage id="messages.previous" />
                      </span>
            </PaginationLink>
          </PaginationItem>
          <PaginationItem className="mx-2">
            <Input
              type="select"
              name="selectPage"
              id="selectPage"
              value={ currentPage }
              onChange={(e) => this.props.changePage(e.target.value)}
            >
              { mobilePaginatorElements.map((item) => {
                return this.renderMobilePaginationElements(item,totalPage);
              }) }
            </Input>
          </PaginationItem>
          <PaginationItem className={(currentPage === totalPage ? 'disabled' : 'cursor-pointer')}>
            <PaginationLink
              onClick={
                e => {
                  e.preventDefault();
                  this.props.changePage(currentPage + 1);
                }
              }
            >
              <i className="fas fa-angle-right" />
              <span className="sr-only">
                      <FormattedMessage id="messages.next" />
                    </span>
            </PaginationLink>
          </PaginationItem>
        </Pagination>

      </div>
    )
  }
}

export { Mobile }
